/* eslint-disable no-undef */

import React, {Component} from 'react'
import {withStyles} from '@material-ui/core/styles/index'
import {Grid, TextField, FormHelperText, InputAdornment} from '@material-ui/core'
import PersonIcon from '@material-ui/icons/Person'

const styles = theme => ({
    errorText: {
        marginTop: theme.spacing(0.8),
        color: theme.palette.error.main + '!important',
        fontSize: '0.9rem!important',
        textAlign: theme.errorText && theme.errorText.textAlign ? theme.errorText.textAlign : 'center!important'
    },
    questionWrapper: {
        marginTop: '0px!important',
        ...theme.isMobile && {
            padding: '4px!important'
        },
    },
    textField: {
        '& input': {
            borderRadius: theme.input ? theme.input.borderRadius + 'px!important' : null
        },
        '& fieldset': {
            border: theme.input ? theme.input.border + '!important' : null,
            borderRadius: theme.input ? theme.input.borderRadius + 'px!important' : null,
            boxShadow: theme.input ? theme.input.boxShadow + '!important' : null
        }
    },
    outlinedTextField: {
        '& input': {
            background: '#fff'
        }
    },
    inputAdornement: {
        '& p': {
            color: theme.palette.text.secondary + '!important',
            marginRight: theme.spacing(1),
            fontSize: '1rem!important'
        }
    }
})

class TextQuestion extends Component {
    state = {}

    handleChange = event => {
        this.props.onValueChanged(this.props.question.id, event.target.value)
    }

    render() {
        const {classes, value, question, theme} = this.props

        const inputValue = value ? value : ''
        const isRequired = String(question.validation ?? '').includes('required')

        return (
            <Grid item xs={parseInt(question.xsCols)} sm={parseInt(question.smCols)}
                  className={'question-checkboxes ' + classes.questionWrapper + ' question-id-' + question?.id}>
                <TextField
                    required={isRequired}
                    label={question.title}
                    name={question.name}
                    fullWidth
                    variant={theme.inputVariant}
                    autoFocus={question.autoFocus}
                    onChange={this.handleChange}
                    error={question.valid === false}
                    disabled={question.disabled ?? false}
                    value={inputValue}
                    InputProps={{
                        endAdornment: question.unit && (
                            <InputAdornment position="end" className={classes.inputAdornement}>
                                {question.unit}
                            </InputAdornment>
                        )
                    }}
                    className={
                        classes.textField +
                        ' inputText ' +
                        (theme.inputVariant === 'outlined' ? classes.outlinedTextField + ' outlinedInputText' : '')
                    }
                />
                {question.description && <FormHelperText>{question.description}</FormHelperText>}
                {question.valid === false && (
                    <Grid item xs={12} style={{paddingTop: 0}}>
                        <FormHelperText className={classes.errorText}>{question.errorMessage}</FormHelperText>
                    </Grid>
                )}
            </Grid>
        )
    }
}

export default withStyles(styles)(TextQuestion)
